<template>
  <div class="app-wrapper" :class="classObj">
    <!-- <div v-if="!isChannelUser&&device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div> -->
    <!-- <sidebar class="sidebar-container" v-if="getUserInfo() && !isChannelUser"></sidebar> -->
    <div class="main-container">
      <navbar></navbar>
      <tags-view></tags-view>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { getUserInfo } from '@/utils/user-info' // getToken from cookie
const { mapGetters } = Vuex

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters([
      'roles',
      'isChannelUser'
    ]),
    sidebar () {
      return this.$store.state.app.sidebar
    },
    device () {
      return this.$store.state.app.device
    },
    classObj () {
      return 'no-sidebar'
      // if (this.isChannelUser || !this.getUserInfo()) {
      //   return 'no-sidebar'
      // } else {
      //   return {
      //     hideSidebar: !this.sidebar.opened,
      //     withoutAnimation: this.sidebar.withoutAnimation,
      //     mobile: this.device === 'mobile'
      //   }
      // }
    }
  },
  methods: {
    getUserInfo: getUserInfo,
    handleClickOutside () {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue